var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("data.add_new_bank_account"),
            "close-on-click-modal": false,
            width: "739px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" Account Details "),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("tips.enter_bank_accout_detail_add")) + " "
            ),
          ]),
          _c(
            "div",
            { staticClass: "form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rule,
                    model: _vm.form,
                    "status-icon": "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.currency"),
                                prop: "settle_type",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: { disabled: _vm.isUSDOnlyBankAccount },
                                  on: { change: _vm.onCurrencyChange },
                                  model: {
                                    value: _vm.form.settle_type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "settle_type", $$v)
                                    },
                                    expression: "form.settle_type",
                                  },
                                },
                                _vm._l(_vm.currencyList, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.account_location"),
                                prop: "settlement_country",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: {
                                    disabled:
                                      _vm.form.settle_type === 1 ||
                                      (_vm.form.settle_type === 2 &&
                                        _vm.isLocalCurrencyUSD),
                                  },
                                  model: {
                                    value: _vm.form.settlement_country,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "settlement_country",
                                        $$v
                                      )
                                    },
                                    expression: "form.settlement_country",
                                  },
                                },
                                _vm._l(
                                  _vm.accountLocationList,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("merchant.account_bank"),
                                prop: "settlement_bank",
                              },
                            },
                            [
                              _vm.form.settle_type === 2
                                ? _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      autocomplete: "off",
                                      placeholder: "Enter bank name",
                                    },
                                    model: {
                                      value: _vm.form.settlement_bank,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "settlement_bank",
                                          $$v
                                        )
                                      },
                                      expression: "form.settlement_bank",
                                    },
                                  })
                                : _c(
                                    "el-select",
                                    {
                                      staticClass: "select-item",
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        "popper-class": "bank-select-dropdown",
                                      },
                                      model: {
                                        value: _vm.form.settlement_bank,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "settlement_bank",
                                            $$v
                                          )
                                        },
                                        expression: "form.settlement_bank",
                                      },
                                    },
                                    _vm._l(
                                      _vm.bankList,
                                      function (item, index) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: index,
                                            attrs: {
                                              label:
                                                item.bank_code +
                                                "-" +
                                                item.full_name,
                                              value: item.bank_code,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    item.bank_code +
                                                    "-" +
                                                    item.full_name,
                                                  placement: "top",
                                                  disabled: !item._overflow,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "option-ellipsis",
                                                    on: {
                                                      mouseenter: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleOverflow(
                                                          $event,
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.bank_code +
                                                            "-" +
                                                            item.full_name
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _vm.$store.getters.curCountry.country_code === "PH"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("merchant.account_num"),
                                    prop: "settlement_bank_account_num_ph",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "input-item",
                                    attrs: {
                                      clearable: "",
                                      type: "text",
                                      placeholder: "Enter Account",
                                      autocomplete: "off",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.bankAccountPH()
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.form.settlement_bank_account_num_ph,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "settlement_bank_account_num_ph",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.settlement_bank_account_num_ph",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("merchant.account_num"),
                                    prop: "settlement_bank_account_num",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "input-item",
                                    attrs: {
                                      clearable: "",
                                      type: "text",
                                      placeholder: "Enter Account",
                                      autocomplete: "off",
                                    },
                                    model: {
                                      value:
                                        _vm.form.settlement_bank_account_num,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "settlement_bank_account_num",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.settlement_bank_account_num",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.bank_account_holder"),
                                prop: "settlement_bank_account_name",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  autocomplete: "off",
                                  placeholder: "Enter your message here",
                                },
                                model: {
                                  value: _vm.form.settlement_bank_account_name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "settlement_bank_account_name",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.settlement_bank_account_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.bank_address"),
                                prop: "settlement_bank_address",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  autocomplete: "off",
                                  placeholder: _vm.$t("data.bank_address"),
                                },
                                model: {
                                  value: _vm.form.settlement_bank_address,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "settlement_bank_address",
                                      $$v
                                    )
                                  },
                                  expression: "form.settlement_bank_address",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.swift_code"),
                                prop: "swift",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  autocomplete: "off",
                                  placeholder: _vm.$t("data.swift_code"),
                                },
                                model: {
                                  value: _vm.form.swift,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "swift", $$v)
                                  },
                                  expression: "form.swift",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.bank_account_proof"),
                                prop: "attachment_name",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#71110e",
                                            "margin-right": "4px",
                                          },
                                        },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("data.bank_account_proof")
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            placement: "top",
                                            content: _vm.$t(
                                              "data.bank_wallet_tooltip"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              color: "#909399",
                                              "margin-left": "4px",
                                              cursor: "pointer",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "div",
                                [
                                  _vm.form.attachment_name
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "10px",
                                          },
                                        },
                                        [
                                          _vm.isImg(_vm.form.attachment_content)
                                            ? _c(
                                                "div",
                                                { staticClass: "content-file" },
                                                [
                                                  _c("el-image", {
                                                    staticStyle: {
                                                      height: "150px",
                                                    },
                                                    attrs: {
                                                      src: _vm.form
                                                        .attachment_content_oss_url,
                                                      "preview-src-list": [
                                                        _vm.form
                                                          .attachment_content_oss_url,
                                                      ],
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "content-file" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.form.attachment_name
                                                    )
                                                  ),
                                                ]
                                              ),
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "10px",
                                              },
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onClickRemoveBtn()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("components.delete")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "UploadFile",
                                        _vm._g(
                                          {
                                            on: {
                                              templateFileSuccess:
                                                _vm.templateFileSuccess,
                                            },
                                          },
                                          _vm.$listeners
                                        )
                                      ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }